import React from 'react';
var VeltViewAnalytics = function (props) {
    var type = props.type, locationId = props.locationId;
    return (React.createElement("velt-view-analytics", { type: type, "location-id": locationId }));
};
export default VeltViewAnalytics;
